import styled from "@emotion/styled";

type TagProps = {
  bg?: string;
};

const Tag = styled("span")<TagProps>(({ bg, theme }) => ({
  background:
    bg === "gradient"
      ? [theme.colors.pink, theme.gradients.tagFounder]
      : theme.colors[bg ?? "pink"],
  borderRadius: theme.borderRadius.round,
  display: "inline-block",
  fontSize: theme.fontSizes.xs,
  padding: "0.2em .8em .1em .8em",
}));

export { Tag };
